<style lang="stylus" scoped>
.personalcenterwrap
  position: relative
  min-height: 504px
  padding-bottom: 106px
  .personalcenterbanner
    position: absolute
    top: 0
    height: 446px
    width: 100%
    background: url('/static/img/personalcenter_bg.png') bottom no-repeat
  .personalcenterbox
    position: relative
    padding-top: 107px
    .personalcenterhead
      display: flex
      min-height:300px;
      .personalcenterheadleft
        width: 204px
        .headimg
          position: relative
          width: 158px
          height: @width
          margin: 0 auto
          border: 4px solid #fff
          border-radius: 50%
          box-shadow: 10px 10px 57px rgba(80,93,119,0.3)
          background: #fff
          .img1
            width: 100%
            height: @width
            border-radius: 50%
          .img2
            position: absolute
            bottom: 0px
            right: 0px
            width:42px
            height:42px
          .img3
            position:absolute
            width:125px
            height:63px
            top:-35px
            right:12px
        .followchatwrap
          display: flex
          align-items: center
          justify-content: center
          color: #fff
          margin-top: 17px
          .commontoggleicon
            display: flex
            align-items: center
            &:hover
              color: #b4dbfe
            img
              margin-right: 6px
            &:first-child
              margin-top: -3px
          .line
            margin: 0 16px
        .headnum
          color: rgba(255,255,255,0.6)
          margin-top: 19px
          font-size: 12px
          display: flex
          & > div
            flex: auto
            p
              text-align: center
              &:last-child
                margin-top: 4px
      .personalcenterheadright
        margin-left: 52px
        color: #fff
        & > p
          margin-top: 11px
        .namep
          display:flex;
          align-items:center;
          .name
            font-size: 24px
          small
            font-size: 16px
            margin-left: 16px
          .editspan
            font-size: 14px
            margin-left: 26px
            cursor: pointer
            img
              margin-right: 2px
              vertical-align: middle
              margin-top: -4px
        .companyp
          margin-top: 20px
          font-size: 16px
          .line
            margin: 0 20px
            // color: #7676f0
          .address, .phone
            img
              vertical-align: middle
              margin: -3px 10px 0 0
          .loginbtn
            width: 97px
            margin-left: 23px
        .profile
          margin-top: 7px
        .speciality
          font-size: 12px
          span
            display: inline-block
            min-width: 74px
            height: 24px
            line-height: @height
            text-align: center
            margin-right: 5px
            padding: 0 13px
            color: #666
            background: #fff
            border-radius: @height
        .grade
          display: flex
          align-items: center
          margin-top: 15px
          .starwrap
            margin-left: 2px
            img
              vertical-align: middle
              margin-top: -4px
          .tips
            color: rgba(255,255,255,0.6)
            margin-left: 16px
        .growthprogress
          margin-top: 1px
          .progress
            display: inline-block
            width: 200px
            vertical-align: middle
          .progressnum
            margin-left: 11px
          .howquickgrow
            margin-left: 11px
            i
              color: #2751CB
              font-size: 15px
              vertical-align: middle
    .personalcentercont
      margin-top: 90px
      display: flex
      justify-content: space-between
      .personalcentercontleft
        width: 255px
        .personalcentercontleftbox
          .navitemwrap
            .navitem
              height: 44px
              display: flex
              align-items: center
              justify-content: center
              font-size: 16px
              color: #444
              cursor: pointer
              margin-top: 8px
              &:first-child
                margin-top: 0
              &.active
                color: #fff
                font-weight: bold
                background:rgba(39,81,203,1)
                border-radius:26px
                .def
                  display: none
                .hov
                  display: block
              img
                margin-right: 9px
                wodth:23px;
                height:21px;
                &.hov
                    display: none
            .customersetting
              margin-top: 16px
              text-align: center
              button
                height: 44px
                width:100%
                color: #fff
                padding: 0 25px
                border: none
                background: #2751CB
          .relevantlawyers
            .relevantlawyersbox
              margin-left: -8px
              .relevantlawyersimg
                height: 47px
                width: @height
                margin-top: 14px
                margin-left: 8px
                border-radius: 50%
                cursor: pointer
          .hotinformation
            .hotinformationbox
              font-size: 14px
              color: #444
              padding-top: 14px
              .hotinformationlist
                position: relative
                padding-left: 12px
                margin-bottom: 13px
                &:before
                  content: ''
                  display: block
                  width: 4px
                  height: 4px
                  border-radius: 50%
                  position: absolute
                  top: 8px
                  left: 0
                  background:rgba(39,81,203,1)
                a
                  color: #444
                  max-height: 42px
      .personalcentercontright
        width: 880px
        min-height:400px;
        .serviceitemwrap
          //
        .openpostwrap, .caselistwrap
          .openpostbox, .caselistbox
            padding: 26px 31px 0 21px
            ul
              position: relative
              min-height: 50px
              li
                height: 35px
                margin-bottom: 3px
                display: flex
                align-items: center
                justify-content: space-between
                padding: 0 13px 0 34px
                border-radius: @height
                position: relative
                &:before
                  content: ''
                  display: block
                  width: 5px
                  height: 5px
                  border-radius: 50%
                  position: absolute
                  top: 15px
                  left: 17px
                  background: rgba(39,81,203,1)
                &:hover
                  background: #eff7ff
                .title
                  width: 520px
                  color: #333
                .time
                  font-size: 12px
                  color: #76798e
        .caselistwrap
          .caselistbox
            ul
              li
                .title
                  width: 418px
                .time
                  flex: auto
                  display: flex
                  justify-content: space-between
                  .user
                    color: #76798e
        .classiccasewrap
          //
        .commonproblemwrap
          .commonproblembox
            .commonproblemlistbox
              position: relative
              min-height: 50px
              margin-top: 20px
              .commonproblemlist
                padding: 27px 7px
                border-top: 1px solid #f2f5fd
                &:hover
                  .commonproblemlisthead
                    .headright
                      .headrightright
                        display: flex
                &:first-child
                  padding-top: 7px
                  border-top: none
                .commonproblemlisthead
                  display: flex
                  align-items: center
                  .headleft
                    //
                    width: 46px
                  .headright
                    font-size: 16px
                    color: #444
                    display: flex
                    align-items: center
                    justify-content: space-between
                    flex: auto
                    .headrightleft
                      max-width: 711px
                    .headrightright
                      display: none
                      align-items: center
                      span
                        padding: 5px 8px
                .commonproblemlistbot
                  margin-top: 10px
                  display: flex
                  .botleft
                    //
                  .botright
                    width: 828px
                    color: #999
                    white-space pre-wrap
                    word-break: break-word
                    word-wrap: break-word
        .cuscommentwrap
          .cuscommentbox
            padding: 33px 0 0 0
            .cuscommenthead
              .evaluationwrap
                display: flex
                align-items: center
                margin-bottom: 20px
              .tit
                font-size: 16px
                color: #999
                margin-right: 11px
            .cuscommentbot
              position: relative
              min-height: 121px
              .cuscommentlist
                display: flex
                padding: 22px 0 25px
                border-top: 1px solid #f2f5fd
                &:first-child
                  border-top: none
                .cuscommentlistleft
                  width: 62px
                  flex: none
                  img
                    width: 50px
                    height: @width
                    border-radius: 50%
                    cursor: pointer
                .cuscommentlistright
                  flex: auto
                  .name
                    a
                      font-size: 16px
                      color: #444
                      font-weight: bold
                  .evaluation
                    display: flex
                    align-items: center
                    color: #999
                    margin-top: 5px
                    .tit
                      margin-right: 9px
                    .time
                      font-size: 12px
                      color: #999
                      margin-left: 12px
                  .cont
                    width: 825px
                    color: #444
                    margin-top: 5px
                    white-space pre-wrap
                    word-break: break-word
                    word-wrap: break-word
        .sendcasewrap
          .sendcasebox
            padding-top: 25px
            .sendcaseformbtn
              display: flex
              align-items: flex-start
              justify-content: space-between
              margin-top: 5px
  .listspan
    display: inline-block
    width: 23px
    height: @width
    line-height: @width
    font-size: 13px
    color: #fff
    text-align: center
    margin-right: 22px
    background: #f88379
    &.listspana
      background: #2751CB

  .commonpersonalbtn
    // color: rgba(255,255,255,0.75)
    color: #2751CB
    height: 30px
    border: 1px solid #fff
    // background: #4936d8
    background: #fff
    // background-image: linear-gradient(to bottom right, #4e3fd8, #3d1fd7)
  .commonpersonalpanel
    border-radius: 10px
    padding: 21px
    background: #fff
    margin-bottom: 20px
    box-shadow: 6px 6px 62px rgba(177,191,239,0.5)
    .headtitle
      font-size: 18px
      color: rgba(7,19,54,1)
      font-weight:bold
      display:flex
      justify-content:center
      align-items:center
      padding-bottom: 13px
      border-bottom: 1px solid #eaeefc
      .headtitle-dian
        width:7px;
        height:7px;
        background:rgba(39,81,203,1);
        border-radius:50%;
        margin:0 15px;
    &.commonpersonalbigpanel
      padding: 34px 44px 40px 49px
      margin-bottom: 50px
      .headtitle
        font-size: 22px
        color: #444
        display: flex
        align-items: center
        justify-content: space-between
        small
          font-size: 12px
          color: #919191
          margin-left: 16px
        .headedit
          color: #2751CB
          font-size: 14px
          cursor: pointer
          img
            vertical-align: middle
            margin-top: -4px

.commonproblemeditmodal
  .commonproblemeditwrap
    padding: 0 80px
    .commonproblemedittop
      display: flex
      align-items: center
      .topleft
        //
      .topright
        flex: auto
    .commonproblemeditbot
      margin: 5px 0 12px 0
      display: flex
      .botleft
        //
      .botright
        flex: auto
.cussettingmodal
  .cussettingwrap
    padding-top: 11px
    display: flex
    flex-wrap: wrap
    .cussettinglist
      width: 268px
      padding: 0 56px 30px
      margin-bottom: 20px
      // background: url('/static/img/cussettinglist_bg_img.png') center right no-repeat
      &:nth-child(3n)
        background: none
      .headimg
        text-align: center
      .settingtit
        text-align: center
        font-size: 16px
        color: #444
        margin-top: 8px
      .settingdes
        font-size: 12px
        color: #999
        margin-top: 8px
        height: 54px
      .settingset
        text-align: center
        margin-top: 17px
</style>
<style lang="stylus">
  .sendcasebox
    .el-form-item__error
      top:6px !important;
</style>

<template>
  <div class="personalcenterwrap">
    <div class="personalcenterbanner">
    </div>
    <div v-if="userInfo" class="personalcenterbox appwrap">
      <div class="personalcenterhead">
        <div class="personalcenterheadleft">
          <div class="headimg">
            <img :src="$avatarHash(userInfo.id)" class="img1">
            <img v-if="userInfo.is_seeds" src="/static/img/isSeedUser.png" class="img3">
            <img v-if="userInfo.isVip" src="/static/img/isviplawyer1.png" class="img2">
          </div>
          <div v-if="!isMe" class="followchatwrap">
            <span @click="unfollow" v-if="userInfo.fofa == 1 || userInfo.fofa == 3" class="commontoggleicon">取消关注
            </span>
            <span @click="follow" v-else class="commontoggleicon">关注
            </span>
            <span class="line">|</span>
            <span @click="gotoChat" class="commontoggleicon">{{isLawyer ? '咨询' : '私信'}}
            </span>
          </div>
          <div class="headnum">
            <div>
              <p>知识</p>
              <p>{{userInfo.post_num || '0'}}</p>
            </div>
            <div v-if="isLawyer">
              <p>案件</p>
              <p>{{userInfo.case_num || '0'}}</p>
            </div>
            <div>
              <p>关注</p>
              <p>{{userInfo.follow_num || '0'}}</p>
            </div>
            <div>
              <p>粉丝</p>
              <p>{{userInfo.fans_num || '0'}}</p>
            </div>
          </div>
        </div>

        <div class="personalcenterheadright" :style="{paddingTop: isMe ? '0' : '40px'}">
          <p class="namep">
            <span class="name">{{userInfo.real_name||userInfo.name}}</span>
            <img v-if="isLawyer" src="/static/img/islawyer.png" style="width:22px;height:26px;margin-left:12px;">
            <span v-if="userInfo.is_seeds" style="font-size:16px;margin-left:20px;">(种子用户)</span>
            <img v-if="userInfo.is_seeds" src="/static/img/isSeedUser2.png" style="width:25px;height:22px;margin-left:4px;">
            <el-popover v-if="userInfo.is_seeds" trigger="hover" placement="bottom"  width="220" style="margin-left:20px;">
              <div style="font-size:14px;line-height:20px;color:#071336;">
                <div>1、授权终身免费使用</div>
                <div>2、三个月未使用取消授权，</div>
                <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;特殊情况经平台同意可保留</div>
              </div>
              <div style="display:flex;cursor:pointer;align-items:center;" slot="reference">
                <div>种子授权说明</div>
                <img style="width:14px;height:14px;margin-left:4px;" src="/static/img/explain.png">
              </div>
            </el-popover>
            <!-- <small v-if="isLawyer || userInfo.job">{{isLawyer ? $authCodeT(userInfo.vip).role : userInfo.job}}</small> -->
            <span v-if="isMe"  class="editspan" @click="$router.push({path: '/personalSetter/accountSet'})">
              <img src="/static/img/edit.png"> 编辑
            </span>
          </p>
          <p class="companyp">
            <span class="company">{{userInfo.company || (isLawyer ? '未填写执业机构' : '')}}</span>
            <span class="line" v-if="userInfo.company || isLawyer ? true : false">|</span>
            <span v-if="isLawyer" class="address"><img src="/static/img/address1.png">{{(userInfo.province + (userInfo.city == userInfo.province ? '' : userInfo.city) + userInfo.area) || '未填写地址'}}</span>
            <span v-if="isLawyer" class="line">|</span>
            <span class="phone"><img src="/static/img/phone1.png">{{filterphone(userInfo.phone)}}</span>
            <el-button v-if="!loginStatus" @click="$store.commit('changeLoginModalStatus', {display: true, type: 'login'})" class="commonpersonalbtn loginbtn" size="mini" round>登录后可见</el-button>
          </p>
           <!-- id && userInfo.profile.length -->
           <!-- 编辑个人描述 -->
          <p class="profile">
            {{userInfo.profile}}  
          
            <el-popover
              v-if="loginStatus && userInfo.id === $store.state.mineInfo.id"
              placement="bottom"
              width="430"
              @show = showpopover(userInfo.profile)
              v-model="describepopover">
              <el-form >
                <el-form-item >
                  <el-input 
                    type="textarea" 
                    placeholder="请输入自我描述,不超过30字"
                    :autosize="{ minRows: 4, maxRows: 4}"
                    max="30"
                    resize="none"
                    v-model="describeText"
                  ></el-input>
                </el-form-item>
              </el-form>
              <div style="text-align: right; marginTop: 10px">
                <el-button type="primary" size="mini" round @click="sendpopover">保 存</el-button>
              </div>

              <el-button slot="reference" class="commonpersonalbtn loginbtn" size="mini" round>
                编辑个人描述
              </el-button>
            </el-popover>
          </p>

          <p v-if="isLawyer" class="speciality">
            <span v-for="item in userInfo.speciality">{{item.name}}</span>
          </p>
          <p v-if="isLawyer" class="grade">
            当前等级：
            <span class="starwrap">
              <img v-for="star in 5" :src="`/static/img/${star <= userInfo.star ? 'star.png' : 'star_1.png'}`" style="width:16px;height:15px;">
            </span>
            <span class="tips">超过{{userInfo.beyondpercent}}%的律师用户</span>
          </p>
          <p v-if="isLawyer" class="growthprogress">
            成长进度：
            <span class="progress">
              <el-progress :percentage="Number((userInfo.score / userInfo.topscore).toFixed(2)) * 100" :show-text="false" color="#ffd118"></el-progress>
            </span>
            <span class="progressnum">
              {{userInfo.score + ' / ' + userInfo.topscore}}
            </span>
            <el-button v-if="isMe"  class="commonpersonalbtn howquickgrow" size="mini" round>如何快速成长 <i class="el-icon-question"></i></el-button><!-- @click="$goto({name: 'grow'})"跳转快速成长详情页 -->
          </p>
        </div>
      </div>

      <div class="personalcentercont">
        <div class="personalcentercontleft">
          <Affix :offset-top="90">
            <div class="personalcentercontleftbox">
              <!-- 导航 -->
              <div class="navitemwrap commonpersonalpanel">
                <div v-if="nav.showNav" v-for="nav in navList" @click="toggleNav(nav)" :class="{active: nav.isCurNav}" class="navitem">
                  <img v-if="nav.isCurNav" :src="nav.isimg">
                  <img v-else :src="nav.noimg">
                  {{nav.name}}
                </div>

                <div v-if="isMe && isLawyer" class="customersetting">
                  <el-button @click="cusSettingModal = true" size="small" round>自定义设置</el-button>
                </div>
              </div>
              <!-- 相关律师 -->
              <div class="relevantlawyers commonpersonalpanel">
                <div class="headtitle"><span class="headtitle-dian"></span><span>相关律师推荐</span><span class="headtitle-dian"></span></div>
                <div class="relevantlawyersbox">
                  <img v-if="index < 8" v-for="(lawyer, index) in RLawyer" @click="$router.push({name: 'personalCenter', params: {id: lawyer.id}})" @mouseenter="userInfoModule($event, lawyer.id)" @mouseleave="hideUserInfoModule" :src="$avatarHash(lawyer.id)" :title="lawyer.name" class="relevantlawyersimg">
                </div>
              </div>
              <!-- 热门资讯 -->
              <div class="hotinformation commonpersonalpanel">
                <div class="headtitle"><span class="headtitle-dian"></span><span>热门资讯</span><span class="headtitle-dian"></span></div>
                <div class="hotinformationbox">
                  <div v-if="index < 3" v-for="(zixun, index) in RZiXun" class="hotinformationlist" @click="$router.push({name: 'post', params: {post_id: zixun.pid}})"><a class="ellipsis2" >{{zixun.title}}</a></div>
                  <p style="text-align: center;"><a  href="javascript:;">更多资讯</a></p><!-- @click="$goto({name: 'information'})"跳转到更多资讯页 -->
                </div>
              </div>
            </div>
          </Affix>
        </div>

        <div class="personalcentercontright">
          <!-- 服务项目 -->
          <div v-if="navList.find(n => n.key == 'serviceItem').showNav" id="serviceItem" class="serviceitemwrap commonpersonalpanel commonpersonalbigpanel">
            <div class="headtitle">服务项目<span class="headedit"><img src="/static/img/edit_blue.png"> 编辑</span></div>
            <div class="serviceitembox"></div>
          </div>

          <!-- 发布业务 -->
          <div v-if="navList.find(n => n.key == 'sendCase').showNav" id="sendCase" class="sendcasewrap commonpersonalpanel commonpersonalbigpanel">
            <div class="headtitle"><span>发布业务<small>私人法律业务向律师发布法律业务委托</small></span><span @click="$router.push({path: '/legalDepartment'})" class="headedit" style="text-decoration: underline;">发布企业案件？</span></div>
            <div class="sendcasebox">
              <el-form :model="sendCaseForm" :rules="formRules" ref="sendCaseForm" label-width="80px">
                <el-form-item label="业务名称" prop="name">
                  <el-input
                    v-model="sendCaseForm.name"
                    size="small"
                    maxlength="50"
                    class="commoninputwrap">
                  </el-input>
                </el-form-item>
                <el-form-item label="业务内容" prop="content">
                  <el-input
                    v-model="sendCaseForm.content"
                    type="textarea"
                    :rows="6"
                    maxlength="5000"
                    class="commoninputwrap">
                  </el-input>
                </el-form-item>
                <el-form-item label="选择律师" prop="lawyers">
                  <el-select v-model="sendCaseForm.lawyers" size="small" placeholder="选择发送律师" multiple class="commoninputwrap" style="width: 100%;">
                    <el-option v-for="lawyer in caseLawyer" :label="lawyer.name" :value="lawyer.id" :key="lawyer.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <div class="sendcaseformbtn">
                    <div>
                      <el-upload
                        class="uploadwrap"
                        :action="baseUrl"
                        :data="headerData"
                        :file-list="sendCaseFileList"
                        :with-credentials="true"
                        name="upload"
                        :on-success="handleSuccess"
                        :on-remove="handleRemove"
                        :before-remove="beforeRemove"
                        ref="sendCaseUpload">
                        <el-button type="text"><img src="/static/img/upload_icon.png"> 上传附件</el-button>
                      </el-upload>
                    </div>
                    <el-button :loading="sendCaseLoading" @click="sendCaseSubmit" type="primary" size="medium" round>发 布</el-button>
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </div>

          <!-- 案件列表 -->
          <div v-if="navList.find(n => n.key == 'caseList').showNav" id="caseList" class="caselistwrap commonpersonalpanel commonpersonalbigpanel">
            <div class="headtitle">案件列表</div>
            <div class="caselistbox">
              <ul v-loading="caseList.loading">
                <li v-for="list in caseList.list">
                  <a v-if="list.userid" class="title ellipsis1" >{{list.casename}}</a><!-- :href="$gotov1('/business/caseRead/' + list.caseid, true)" 跳转到案件详情-->
                  <a v-else class="title ellipsis1" >{{list.casename}}</a><!-- :href="$gotov1('/personalPage/selectLawyer/' + list.caseid, true)" -->
                  <span class="time">
                    <span>
                      <a v-if="list.userid" @click="$router.push({name: 'personalCenter', params: {id: list.userid}})" class="user" href="javascript:;">办理律师：{{list.username}}</a>
                      <a v-else class="user" href="javascript:;" style="cursor: initial;">未选定</a>
                    </span>
                    <span>{{list.time}}</span>
                  </span>
                </li>
                <div v-if="!caseList.list.length && !caseList.loading" class="nodatalist">
                  暂无相关案件
                </div>
              </ul>
            </div>
          </div>

          <!-- 公开知识 -->
          <div v-if="navList.find(n => n.key == 'open_post').showNav" id="open_post" class="openpostwrap commonpersonalpanel commonpersonalbigpanel">
            <div class="headtitle">公开知识</div>
            <div class="openpostbox">
              <ul v-loading="openPost.loading">
                <li v-for="post in openPost.list" @click="$router.push({name: 'post', params: {post_id: post.pid}})"><a class="title ellipsis1" >{{post.title}}</a><span class="time">{{post.updated_at}}</span></li>
                <div v-if="!openPost.list.length && !openPost.loading" class="nodatalist">
                  暂未创建公开知识
                </div>
              </ul>
              <div v-if="openPost.list.length" class="commonpagenav">
                <el-pagination
                  background
                  layout="prev, pager, next, total"
                  @current-change="openPostPageChange"
                  :current-page.sync="openPost.page"
                  :page-size="openPost.perpage"
                  :total="openPost.total">
                </el-pagination>
              </div>
            </div>
          </div>

          <!-- 经典案例 -->
          <div v-if="navList.find(n => n.key == 'classicCase').showNav" id="classicCase" class="classiccasewrap commonpersonalpanel commonpersonalbigpanel">
            <div class="headtitle">经典案例<span class="headedit"><img src="/static/img/edit_blue.png"> 编辑</span></div>
            <div class="classiccasebox"></div>
          </div>

          <!-- 常见问题 -->
          <div v-if="navList.find(n => n.key == 'common_question').showNav" id="common_question" class="commonproblemwrap commonpersonalpanel commonpersonalbigpanel">
            <div class="headtitle">常见问题<span v-if="isMe" @click="commonProblemEdit(false)" class="headedit"><img src="/static/img/edit_bule.png"> 编辑</span></div>
            <div class="commonproblembox">
              <div class="commonproblemlistbox" v-loading="commonProblem.loading">
                <div v-for="problem in commonProblem.list" class="commonproblemlist">
                  <div class="commonproblemlisthead">
                    <div class="headleft"><span class="listspan listspanq">Q</span></div>
                    <div class="headright">
                      <div class="headrightleft ellipsis1" :title="problem.question">{{problem.question}}</div>
                      <div v-if="isMe" class="headrightright">
                        <span @click="commonProblemDel(problem.id)" class="commontoggleicon">
                          <img src="/static/img/del_icon.png" class="commontoggleiconimg def" width="12">
                          <img src="/static/img/del_icon_hover.png" class="commontoggleiconimg hov" width="12">
                        </span>
                        <span @click="commonProblemEdit(problem)" class="commontoggleicon">
                          <img src="/static/img/pen_icon.png" class="commontoggleiconimg def">
                          <img src="/static/img/pen_icon_hover.png" class="commontoggleiconimg hov">
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="commonproblemlistbot">
                    <div class="botleft"><span class="listspan listspana">A</span></div>
                    <div class="botright">{{problem.answer}}</div>
                  </div>
                </div>
                <div v-if="!commonProblem.list.length && !commonProblem.loading" class="nodatalist">
                  暂未创建常见问题
                </div>
              </div>
              <div v-if="commonProblem.list.length" class="commonpagenav">
                <el-pagination
                  background
                  layout="prev, pager, next, total"
                  @current-change="commonProblemPageChange"
                  :current-page.sync="commonProblem.page"
                  :page-size="commonProblem.perpage"
                  :total="commonProblem.total">
                </el-pagination>
              </div>
            </div>
          </div>

          <!-- 客户评价 -->
          <div v-if="navList.find(n => n.key == 'clientele_evaluate').showNav" id="clientele_evaluate" class="cuscommentwrap commonpersonalpanel commonpersonalbigpanel">
            <div class="headtitle">客户评价</div>
            <div class="cuscommentbox">
              <div class="cuscommenthead">
                <p class="evaluationwrap"><span class="tit">总体评价</span> <el-rate v-model="evaluationForm.rate"></el-rate></p>
                <el-form :model="evaluationForm" :rules="formRules" ref="evaluationForm">
                  <el-form-item prop="evaluate">
                    <el-input
                      v-model="evaluationForm.evaluate"
                      type="textarea"
                      :rows="5"
                      maxlength="500"
                      placeholder="请写下您对律师的评价"
                      class="commoninputwrap">
                    </el-input>
                  </el-form-item>
                  <el-form-item style="margin-top: 18px; text-align: right;">
                    <el-checkbox v-model="evaluationForm.anonymity" style="margin-right: 20px;">匿名</el-checkbox>
                    <el-button @click="evaluationSubmit" type="primary" size="medium" round>提 交</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="cuscommentbot" v-loading="evaluation.loading">
                <div v-for="item in evaluation.list" class="cuscommentlist">
                  <div class="cuscommentlistleft">
                    <img v-if="!item.anonymity" @click="$router.push({name: 'personalCenter', params: {id: item.creator}})" :src="$avatarHash(item.creator)">
                    <img v-else src="/static/img/anonymity.png" style="cursor: initial;">
                  </div>
                  <div class="cuscommentlistright">
                    <p class="name">
                      <a v-if="!item.anonymity" @click="$router.push({name: 'personalCenter', params: {id: item.creator}})" href="javascript:;">{{item.creatorName}}</a>
                      <a v-else href="javascript:;" style="cursor: initial;">匿名用户</a>
                    </p>
                    <p class="evaluation"><span class="tit">总体评价</span> <el-rate v-model="item.star" disabled></el-rate><span class="time">{{item.updated_at}}</span></p>
                    <p class="cont">{{item.content}}</p>
                  </div>
                </div>
                <div v-if="!evaluation.list.length && !evaluation.loading" class="nodatalist">
                  暂无客户评价
                </div>
              </div>
              <div v-if="evaluation.list.length" class="commonpagenav">
                <el-pagination
                  background
                  layout="prev, pager, next, total"
                  @current-change="evaluationPageChange"
                  :current-page.sync="evaluation.page"
                  :page-size="evaluation.perpage"
                  :total="evaluation.total">
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 常见问题编辑弹框 -->
    <el-dialog
      title="添加常见问题"
      :visible.sync="commonProblemEditModal"
      :close-on-click-modal="false"
      width="850px"
      custom-class="commoneldialogwrap commonproblemeditmodal">
      <div class="commonproblemeditwrap">
        <el-form :model="commonProblemForm" :rules="formRules" ref="commonProblemForm">
          <div class="commonproblemedittop">
            <div class="topleft"><span class="listspan listspanq">Q</span></div>
            <div class="topright">
              <el-form-item prop="question">
                <el-input
                  v-model="commonProblemForm.question"
                  size="small"
                  maxlength="50"
                  placeholder="输入问题"
                  class="commoninputwrap">
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="commonproblemeditbot">
            <div class="botleft"><span class="listspan listspana">A</span></div>
            <div class="botright">
              <el-form-item prop="answer">
                <el-input
                  v-model="commonProblemForm.answer"
                  type="textarea"
                  :rows="7"
                  maxlength="500"
                  placeholder="输入答案"
                  class="commoninputwrap">
                </el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
        <div style="text-align: right;">
          <el-button @click="commonProblemSubmit" type="primary" size="medium" round>保 存</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 自定义设置 -->
    <el-dialog
      title="自定义设置"
      :visible.sync="cusSettingModal"
      :close-on-click-modal="false"
      @close="modalFandleClose"
      width="850px"
      custom-class="commoneldialogwrap cussettingmodal">
      <div class="cussettingwrap">
        <div v-if="!nav.disable" v-for="(nav, index) in navList" class="cussettinglist">
          <p class="headimg"><img :src="`/static/img/personalcentercont_navitem_big${nav.id}${nav.setShowStateSet ? '_' : ''}.png`"></p>
          <p class="settingtit">{{nav.name}}</p>
          <p class="settingdes ellipsis3">{{nav.desInfo}}</p>
          <p class="settingset">
            <el-radio v-model="nav.setShowStateSet" :label="true">显示</el-radio>
            <el-radio v-model="nav.setShowStateSet" :label="false" style="margin-left: 14px;">隐藏</el-radio>
          </p>
        </div>
      </div>
      <div style="text-align: center;">
        <el-button @click="cusSettingFn" type="primary" size="medium" round style="padding: 10px 56px;">确定修改</el-button>
      </div>
    </el-dialog>

    <!-- 用户个人信息面板 -->
    <userInfo
      v-show="userInfoShow"
      :flowModule="true"
      :userList="userObjShow"
      ref="userInfo">
    </userInfo>
  </div>
</template>

<script>
import Affix from '@/components/affix';
import {toTop} from '@/common/js/toTop';
import userInfo from '@/components/userInfo';
import moment from "moment";

export default {
  name: 'PersonalCenter',
  data() {
    return {
      userInfo: null,
      isLawyer: false,
      navList: [
        {
          id: 1,                      // 此参数影响图片显示
          name: '服务项目',
          key: 'serviceItem',
          isimg: '../../../static/img/person_44.png',
          noimg: '../../../static/img/person_4.png',
          isCurNav: false,            // 是否当前
          disable: true,              // 是否禁用
          showNav: true,              // 是否显示
          setShowState: true,         // 自定义设置时初始化的状态
          setShowStateSet: true,      // 自定义设置时设置的状态 保存时值赋给 setShowState
          desInfo: '向客户展示您的法律服务项目，内容包括：服务项目说明以及报价等',    // 描述
          funName: '',
          showType: [1],              // 1 律师个人页面显示  2 普通用户个人页面显示  3 律师外访  4 普通用户外访
        },
        {
          id: 6,
          name: '发布业务',
          key: 'sendCase',
          isimg: '../../../static/img/person_22.png',
          noimg: '../../../static/img/person_2.png',
          isCurNav: false,
          disable: false,
          showNav: true,
          setShowState: true,
          setShowStateSet: true,
          desInfo: '知识模块中，所有公开知识将在此页面中展示，访问者可浏览',
          funName: '',
          showType: [2],
        },
        {
          id: 7,
          name: '案件列表',
          key: 'caseList',
          isimg: '../../../static/img/person_33.png',
          noimg: '../../../static/img/person_3.png',
          isCurNav: false,
          disable: false,
          showNav: true,
          setShowState: true,
          setShowStateSet: true,
          desInfo: '知识模块中，所有公开知识将在此页面中展示，访问者可浏览',
          funName: 'getCaseList',
          showType: [2],
        },
        {
          id: 2,
          name: '公开知识',
          key: 'open_post',
          isimg: '../../../static/img/person_44.png',
          noimg: '../../../static/img/person_4.png',
          isCurNav: false,
          disable: false,
          showNav: true,
          setShowState: true,
          setShowStateSet: true,
          desInfo: '知识模块中，所有公开知识将在此页面中展示，访问者可浏览',
          funName: 'getOpenPost',
          showType: [1, 2, 3, 4],
        },
        {
          id: 3,
          name: '经典案例',
          key: 'classicCase',
          isimg: '../../../static/img/person_44.png',
          noimg: '../../../static/img/person_4.png',
          isCurNav: false,
          disable: true,
          showNav: true,
          setShowState: true,
          setShowStateSet: true,
          desInfo: '您可以再知识板块编辑好您的案例，选择推送至经典案例，增加客户的信赖度',
          funName: '',
          showType: [1],
        },
        {
          id: 4,
          name: '常见问题',
          key: 'common_question',
          isimg: '../../../static/img/person_55.png',
          noimg: '../../../static/img/person_5.png',
          isCurNav: false,
          disable: false,
          showNav: true,
          setShowState: true,
          setShowStateSet: true,
          desInfo: '向客户展示一些普遍的法律问题，问答都可由您自己编辑',
          funName: 'getCommonProblem',
          showType: [1, 3],
        },
        {
          id: 5,
          name: '客户评价',
          key: 'clientele_evaluate',
          isimg: '../../../static/img/person_66.png',
          noimg: '../../../static/img/person_6.png',
          isCurNav: false,
          disable: false,
          showNav: true,
          setShowState: true,
          setShowStateSet: true,
          desInfo: '向客户展示您的所创建或者加入的公开社群，更有利于客户了解您与您的团队',
          funName: 'getEvaluation',
          showType: [1, 3],
        },

      ],
      RLawyer: [],
      RZiXun: [],
      // 公开知识
      openPost: {
        list: [],
        loading: false,
        page: 1,
        perpage: 8,
        total: 0
      },
      // 常见问题
      commonProblem: {
        list: [],
        loading: false,
        page: 1,
        perpage: 3,
        total: 0
      },
      commonProblemEditModal: false,
      commonProblemForm: {
        id: null,
        question: '',
        answer: ''
      },
      formRules: {
        question: [
          { required: true, message: '问题不能为空', trigger: 'blur' }
        ],
        answer: [
          { required: true, message: '回答不能为空', trigger: 'blur' }
        ],
        evaluate: [
          { required: true, message: '评价不能为空', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '业务名称不能为空', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '业务内容不能为空', trigger: 'blur' }
        ],
        lawyers: [
          { required: true, message: '请选择律师', trigger: 'select' }
        ],
      },
      // 客户评价
      evaluation: {
        list: [],
        loading: false,
        page: 1,
        perpage: 3,
        total: 0
      },
      evaluationForm: {
        rate: 5,
        evaluate: '',
        anonymity: false
      },
      // 发布业务
      sendCaseForm: {
        name: '',
        content: '',
        lawyers: [],
        personal: true
      },
      sendCaseFileList: [],
      baseUrl: `${$conf.baseUrl}file/upload`,
      headerData: {
        about_type: 'biz_case_node_flows',
        about_id: -1,
      },
      sendCaseLoading: false,
      caseLawyer: [],
      // 案件列表
      caseList: {
        list: [],
        loading: false,
      },
      // 自定义设置
      cusSettingModal: false,
      userInfoShow: false,
      userObjShow: {},
      // 编辑个人描述
      describepopover: false,
      describeText: ''

    }
  },
  components: {Affix, userInfo},
  computed: {
    loginStatus() {
      return this.$store.state.loginStatus;
    },
    isMe() {
      return this.$store.state.mineInfo && this.$route.params.id == this.$store.state.mineInfo.id;
    },
  },
  beforeMount() {
    let id = this.$route.params.id;
    // if( id == HONSEN_id ){
    //   this.$gotov1('/personalPage/personalCenter/' + id);
    //   return;
    // }
    // 弘商管家单独页面
    this.getUserInfo(id);
    this.getRecommendLawyer();
    this.getRecommendZiXun();
  },
  methods: {
    getUserInfo(id) {
      this.$ajax('get', `/userinfo/detail/${id}`, (data) => {
        data.data.province = data.data.province || '';
        data.data.city = data.data.city || '';
        data.data.area = data.data.area || '';
        data.data.haveAddress = data.data.province + data.data.city + data.data.area;

        this.userInfo = data.data;
        this.isLawyer = this.$authCodeT(this.userInfo.vip).isLawyer;

        // 判断用户在此页面的身份
        let showType = '';
        if( this.isMe ){
          if( this.isLawyer ){
            showType = 1;
          }else{
            showType = 2;
          }
        }else{
          if( this.isLawyer ){
            showType = 3;
          }else{
            showType = 4;
          }
        }

        // 先把不属于对应身份的导航禁用 并且隐藏
        this.navList.forEach(e => {
          if( e.disable || !e.showType.includes(showType) ){
            e.disable = true;
            e.showNav = false;
          }
        });

        this.getModuledetails();
      });
    },
    getModuledetails() {
      this.$ajax('get', 'user/homepage/moduledetails', {uid: this.userInfo.id}, data => {
        let authObj = data.data[0];

        if( this.isLawyer ){
          // 如果是自己 不受权限影像
          for( let key in authObj ){
            if( this.navList.find(e => e.key == key) ){
              if( this.isMe ){
                this.navList.find(e => e.key == key).setShowState = !!authObj[key];
                this.navList.find(e => e.key == key).setShowStateSet = !!authObj[key];
                this.navList.find(e => e.key == key).showNav = !!authObj[key];
              }else{
                this.navList.find(e => e.key == key).showNav = !!authObj[key];
              }
            }
          }
        }

        // 设置当前 nav 为第一项
        if( this.navList.length ){
          this.navList.find(e => e.showNav).isCurNav = true;
        }

        // 根据显示出来的获取数据 是自己就取所有的
        if( this.isMe ){
          this.getOpenPost();   // 知识是公共都有的
          if( this.isLawyer ){
            this.getCommonProblem();
            this.getEvaluation();
          }else{
            this.getCaseList();
            this.getCaseLawyer();
          }
        }else{  // 不是自己就取显示出来的
          this.navList.filter(e => e.showNav).forEach(e => e.funName ? this[e.funName]() : '');
        }
      });
    },
    getRecommendLawyer() {
      this.$ajax('get', 'searchpage/lawyerrecommend', {position: this.$store.state.locationCity.length ? this.$store.state.locationCity.join('-') : '全国'}, data => {
        this.RLawyer = data.data;
      }, err => {});
    },
    getRecommendZiXun() {
      this.$ajax('get', 'searchpage/informationrecommend', data => {
        this.RZiXun = data.data;
      }, err => {});
    },
    toggleNav(nav) {
      this.navList.forEach(e => e.isCurNav = false);
      nav.isCurNav = true;
      toTop(nav.key);
    },
    // 公开知识
    getOpenPost() {
      let param = {
        uid: this.userInfo.id,
        page: this.openPost.page,
        perpage: this.openPost.perpage
      };

      this.$ajax('get', 'post/openpostlist', param, 'openPost.loading', data => {
        this.openPost.list = data.data.data;
        this.openPost.total = data.data.total;
      });
    },
    openPostPageChange() {
      this.getOpenPost();
    },
    // 常见问题
    getCommonProblem() {
      let param = {
        uid: this.userInfo.id,
        page: this.commonProblem.page,
        perpage: this.commonProblem.perpage
      };

      this.$ajax('get', 'commonquestion/list', param, 'commonProblem.loading', data => {
        this.commonProblem.list = data.data.data;
        this.commonProblem.total = data.data.total;
      });
    },
    commonProblemPageChange() {
      this.getCommonProblem();
    },
    commonProblemDel(id) {
      // 弹窗组件confirm使用
      this.$messageAlert({
        type: 'confirm',
        text: '确认删除此问题？',
        cancel: () => {

        },
        ok: () => {
          this.$ajax('get', 'commonquestion/delete', {id: id}, data => {
            if( this.commonProblem.list.length <= 1 ){
              this.commonProblem.page -= 1;
            }
            this.getCommonProblem();
            this.$message.success('成功删除！');
          });
        }
      });
    },
    commonProblemEdit(obj) {
      // 传了obj是修改，没传是添加
      if( obj ){
        this.commonProblemForm = {
          id: obj.id,
          question: obj.question,
          answer: obj.answer
        };
      }else{
        // 清空表单
        this.commonProblemForm = {
          id: null,
          question: '',
          answer: ''
        };
      }
      this.commonProblemEditModal = true;
    },
    commonProblemSubmit() {
      this.$refs.commonProblemForm.validate(valid => {
        if( valid ){
          let param = {
              question: this.commonProblemForm.question,
              answer: this.commonProblemForm.answer
          };
          let url = 'commonquestion/create';
          if( this.commonProblemForm.id ){
            param.id = this.commonProblemForm.id;
            url = 'commonquestion/edit';
          }
          this.$ajax('post', url, param, data => {
            // 清空表单
            this.commonProblemForm = {
              id: null,
              question: '',
              answer: ''
            };
            this.commonProblem.page = 1;
            this.getCommonProblem();
            this.$message.success('成功创建问题！');
          });
          this.commonProblemEditModal = false;
        }
      });
    },
    // 客户评价
    getEvaluation() {
      let param = {
        uid: this.userInfo.id,
        page: this.evaluation.page,
        perpage: this.evaluation.perpage
      };

      this.$ajax('get', 'clienteleevaluate/list', param, 'evaluation.loading', data => {
        this.evaluation.list = data.data.data;
        this.evaluation.total = data.data.total;
      });
    },
    evaluationPageChange() {
      this.getEvaluation();
    },
    evaluationSubmit() {
      if( !this.loginStatus ){
        this.$store.commit('changeLoginModalStatus', {display: true, type: 'login'});
        setTimeout(() => {
          this.$message.warning( '请先登录后，再次执行操作！' );
        }, 200);
        return;
      }
      this.$refs.evaluationForm.validate(valid => {
        if( valid ){
          let param = {
            uid: this.userInfo.id,
            star: this.evaluationForm.rate,
            content: this.evaluationForm.evaluate,
            anonymity: this.evaluationForm.anonymity ? 1 : 0
          };
          this.$ajax('post', 'clienteleevaluate/create', param, data => {
            this.getEvaluation();
            this.evaluationForm = {
              rate: 5,
              evaluate: '',
              anonymity: false
            };
            this.$message.success('评价成功！');
          })
        }
      });
    },
    // 案件列表
    getCaseList() {
      let option = {}
      if (this.$store.state.mineInfo.vip < 420) {
        option.source = 'pc'
      }
      this.$ajax('get', 'biz/case/mycaselist', option, 'caseList.loading', data => {
        let arr = [];
        let arr1 = data.data.firm;
        let arr2 = data.data.person.data;
        arr1.forEach(e => {
          e.cases.data.forEach(i => {
            arr.push({
              caseid: i.caseid,
              casename: i.casename,
              userid: e.lawyer.id,
              username: e.lawyer.name,
              time: i.time,
              sortFlag: moment(i.time).unix()
            });
          });
        });
        arr2.forEach(e => {
          arr.push({
            caseid: e.caseid,
            casename: e.casename,
            userid: e.creator,
            username: e.lawyer,
            time: e.time,
            status: e.status,
            sortFlag: moment(e.time).unix()
          });
        });
        arr.sort((a, b) => b.sortFlag - a.sortFlag);
        this.caseList.list = arr;
      });
    },
    // 发布业务
    getCaseLawyer() {
      this.$ajax('get', 'biz/case/getuserfollowlawyers', data => {
        this.caseLawyer = data.data;
      });
    },
    handleSuccess(res, file, fileList) {
      this.sendCaseFileList = fileList;
    },
    handleRemove(file, fileList) {
      this.sendCaseFileList = fileList;
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${ file.name }？`);
    },
    sendCaseSubmit() {
      this.$refs.sendCaseForm.validate(valid => {
        if( valid ){
          let filesjson = [];
          this.sendCaseFileList.forEach(e => {
            filesjson.push({
              name: e.name,
              hash: e.response.hash,
              creatorflag: 1,
              pushflag: 1
            });
          });

          let params = {...{filesjson: JSON.stringify(filesjson), hash_strs: filesjson.map(e => e.hash)}, ...this.sendCaseForm};

          this.$ajax('post', 'biz/case/issuecase', params, 'sendCaseLoading', data => {
            this.$refs.sendCaseForm.resetFields();
            this.sendCaseFileList = [];
            this.getCaseList();
            this.$message.success('业务发布成功！');
          });
        }
      })
    },
    follow() {
      if( !this.loginStatus ){
        this.$store.commit('changeLoginModalStatus', {display: true, type: 'login'});
        setTimeout(() => {
          this.$message.warning('请先登录后，再次执行操作！');
        }, 200);
        return;
      }
      this.$ajax('post', 'user/follow/' + this.userInfo.id, data => {
        this.userInfo.fofa = 1;
        this.$message.success('关注成功！');
      });
    },
    unfollow() {
      this.$ajax('post', 'user/unfollow/' + this.userInfo.id, data => {
        this.userInfo.fofa = 0;
        this.$message.success('已取消关注！');
      });
    },
    modalFandleClose() {
      this.navList.forEach(e => {
        e.setShowStateSet = e.setShowState;
      });
    },
    cusSettingFn() {
      if( !this.navList.filter(e => e.showNav && e.setShowStateSet).length ){
        this.$message.error('请至少展示一项！');
        return;
      }

      let param = {};
      let tempObj = {};
      let setObj = this.navList.filter(e => !e.show).map(e => {let o = {}; o[e.key] = e.setShowStateSet ? 1 : 0; return o;});
      setObj.forEach(e => tempObj = {...tempObj, ...e});
      param = {...tempObj};
      this.$ajax('post', 'user/homepage/moduleset', param, data => {
        this.navList.forEach(e => {
          if( !e.disable ){   // 没被禁用的才能设置状态
            e.setShowState = e.setShowStateSet;
            e.showNav = e.setShowStateSet;
          }
        });
        this.cusSettingModal = false;
        this.$message.success('自定义设置成功！');
      });
    },
    filterphone(str) {
      let r = '未填写手机号';
      if( str ){
        r = this.loginStatus ? str : str.replace(/(\d{3})\d{4}(\d{4})/g, '$1****$2');
      }
      return r;
    },
    userInfoModule(event, item) {
      let e = event || window.event;
      this.timer = setTimeout(() => {
        this.$ajax('get', `userinfo/detail/${item}`, data => {
          data.data.isStar = (5 - data.data.star);
          this.userObjShow = data.data;
          this.$nextTick(() => {
            this.$refs.userInfo.boxCard(item, e);
            this.userInfoShow = true;
          });
        });
      }, 500);
    },
    hideUserInfoModule() {
      clearTimeout(this.timer);
      this.userInfoShow = false;
    },
    gotoChat() {
      if( !this.loginStatus ){
        this.$store.commit('changeLoginModalStatus', {display: true, type: 'login'});
        setTimeout(() => {
          this.$message.warning( '请先登录后，再次执行操作！' );
        }, 200);
        return;
      }
      // this.$gotov1('/feed?v2chat=' + this.userInfo.id);
      this.startGetInfo(this.userInfo.id)

    },

    startGetInfo(uid) {
      this.$ajax('get', `/userinfo/detail/${uid}`, (data) => {
          this.startChat(data.data);
      });
    },
    startChat(user) {
        if(this.$store.state.mineInfo && this.$store.state.mineInfo.id){
            this.$store.commit("changeCurcontactInfo", { id: user.id, name: user.name});

            if(!this.isshowchatpanel){
                this.$store.commit('setSide', 'chat');
            }
        }else{
            this.$Message.error('未登录，请先登录后再发起私信！');
        }
    },
    // 弹出popover时获取最新的描述
    showpopover(text) {
      this.describeText = text || ''
    },
    sendpopover() {
      if(this.describeText.length === 0 || this.describeText === null) {
        this.$message.error('描述不能为空')
        return false
      }
      if (this.describeText.length > 30) {
        this.$message.error('长度在1-30之间')
        return false
      }
      let param = {
        nickname: this.$store.state.mineInfo.name,
        profile: this.describeText
      }
      this.$ajax('post','/userinfo/setuserinfo', param, res => {
        this.$message.success('编辑成功')
        this.describepopover = false
        this.getUserInfo(this.$store.state.mineInfo.id)
      })
      // console.log(this.describeText)
    }
  },
  filters: {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/personalpage/personalCenter.vue